import React, { useState } from "react";
import { useAuth } from "../context/auth";
import axios from "axios";
import { Link } from "react-router-dom";
import { useWishlist } from "../context/WishlistContext";
const AddtoWishlist = ({ p_id }) => {
  const [auth] = useAuth();
  const [resMsg, setResMsg] = useState({});
  const [wishCls, setWishCls] = useState("");
  const [wishAlert, setWishAlert] = useState("");
  const { wishlist, addToWishlist, removeFromWishlist } = useWishlist();

  const handleWishList = async (p_id) => {
    setResMsg({});
    try {
      //console.log(auth)
      if (!auth.user) {
        setWishAlert(true);
        setTimeout(function () {
          setWishAlert(false);
        }, 5000);
        //alert('Please login!')
        //setResMsg({cls:'text-danger', msg:'Please login!'});
        return false;
      }

      const isInWishlist = wishlist.some((item) => item.product_id === p_id);

      if (isInWishlist) {
        await removeFromWishlist(auth.user.id, p_id, 0);
        setResMsg({ cls: "text-success", msg: "Removed successfully!" });
        setTimeout(function () {
          setResMsg({});
        }, 3000);
      } else {
        setWishCls("loading-wishlist");
        const data = await addToWishlist(auth.user.id, p_id);
        if (data.status) {
          setResMsg({ cls: "text-success", msg: "Added successfully!" });
          setTimeout(function () {
            setResMsg({});
          }, 3000);
          setWishCls("completed");
        } else if (!data.status) {
          setResMsg({ cls: "text-danger", msg: "Already added!" });
          setWishCls("not-completed");
          setTimeout(function () {
            setResMsg({});
          }, 3000);
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const closeBtn = () => {
    setWishAlert(false);
    return false;
  };
  return (
    <>
      <button
        type="button"
        className={`wishlist-btn ${
          wishlist.some((item) => item.product_id === p_id)
            ? "not-completed"
            : ""
        }`}
        onClick={() => handleWishList(p_id)}
      >
        {wishlist.some((item) => item.product_id === p_id) ? (
          <i className="fa-regular fa-heart"></i> // Filled heart if in wishlist
        ) : (
          <i className="fa-regular fa-heart"></i> // Outline heart if not in wishlist
        )}
      </button>

      {resMsg?.msg && <div className={`${resMsg.cls}`}>{resMsg.msg}</div>}

      {wishAlert && (
        <>
          <div className="login-div">
            <span className="close-login-div" onClick={closeBtn}>
              &times;
            </span>
            You need to login to wishlist the product.{" "}
            <Link to="/loginsignup">Log In/Sign up</Link>
          </div>
          <div className="login-div-overlay"></div>
        </>
      )}
    </>
  );
};

export default AddtoWishlist;
